module.exports = __webpack_public_path__ + "assets/img/firstPrize.69c05122.png";